var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDownFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_41615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77527 0.579628L6.8323 4.28816C7.04947 4.55544 6.86571 4.94801 6.52326 4.94801H0.400838C0.0583831 4.94801 -0.125373 4.54709 0.0917933 4.28816L3.14883 0.579628C3.30753 0.38752 3.60822 0.38752 3.77527 0.579628Z",
    fill: "#616E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14883 11.4192L0.0917933 7.71063C-0.125373 7.44335 0.0583831 7.05078 0.400838 7.05078H6.52326C6.86571 7.05078 7.04947 7.4517 6.8323 7.71063L3.77527 11.4192C3.61657 11.6113 3.31588 11.6113 3.14883 11.4192Z",
    fill: "#616E87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_41615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownFilterIcon);
export default __webpack_public_path__ + "static/media/upDownFilterIcon.d015dd46010ce02ca4e244c262d0260b.svg";
export { ForwardRef as ReactComponent };